import React from 'react'
import TopSection from '../Components/About/TopSection';
import MidSection from '../Components/About/MidSection';
import MemberSpeech from '../Components/About/MemberSpeech';
import FaQ from '../Components/FaQ';

const About = () => {
  return (
    <div>
      <TopSection />
      <MidSection />
      <MemberSpeech />
      <FaQ />
    </div>
  )
}

export default About;